module.exports = __webpack_public_path__ + "img/add-icon.f08afc78.svg";